(() => {
  function normalizePosterKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/,/g, '.')
      .replace(/["']/g, '')
      .replace(/[^a-z0-9.()x]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  const DEFAULT_PLACEMENT = {
    x: 260,
    y: 280,
    width: 500,
    height: 500,
    designOpacity: 1
  };

  const PLACEMENTS = {
    a1: { x: 260, y: 280, width: 500, height: 500, designOpacity: 1 },
    a2: { x: 250, y: 270, width: 520, height: 520, designOpacity: 1 },
    '5x7': { x: 260, y: 280, width: 500, height: 500, designOpacity: 1 },
    '8x10': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '10x10': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '11x14': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '12x12': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '12x16': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '12x18': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '14x14': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '16x16': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '16x20': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '18x18': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '18x24': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '20x30': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 },
    '24x36': { x: 330, y: 350, width: 360, height: 360, designOpacity: 1 }
  };

  const PLACEMENT_ALIASES = [
    { key: 'a1', aliases: ['a1', '23.3x33.1', '23 3x33 1', '23.3 x 33.1', '23 3 x 33 1'] },
    { key: 'a2', aliases: ['a2', '16.5x23.3', '16 5x23 3', '16.5 x 23.3', '16 5 x 23 3'] },
    { key: '5x7', aliases: ['5x7', '5 x 7'] },
    { key: '8x10', aliases: ['8x10', '8 x 10'] },
    { key: '10x10', aliases: ['10x10', '10 x 10'] },
    { key: '11x14', aliases: ['11x14', '11 x 14'] },
    { key: '12x12', aliases: ['12x12', '12 x 12'] },
    { key: '12x16', aliases: ['12x16', '12 x 16'] },
    { key: '12x18', aliases: ['12x18', '12 x 18'] },
    { key: '14x14', aliases: ['14x14', '14 x 14'] },
    { key: '16x16', aliases: ['16x16', '16 x 16'] },
    { key: '16x20', aliases: ['16x20', '16 x 20'] },
    { key: '18x18', aliases: ['18x18', '18 x 18'] },
    { key: '18x24', aliases: ['18x24', '18 x 24'] },
    { key: '20x30', aliases: ['20x30', '20 x 30'] },
    { key: '24x36', aliases: ['24x36', '24 x 36'] }
  ];

  function findPlacementKey(candidate) {
    const normalized = normalizePosterKey(candidate);
    if (!normalized) return null;

    if (PLACEMENTS[normalized]) {
      return normalized;
    }

    for (const { key, aliases } of PLACEMENT_ALIASES) {
      for (const alias of aliases) {
        const normalizedAlias = normalizePosterKey(alias);
        if (normalized === normalizedAlias || normalized.includes(normalizedAlias)) {
          return key;
        }
      }
    }

    return null;
  }

  function getPlacementForVariant(...candidates) {
    for (const candidate of candidates) {
      const placementKey = findPlacementKey(candidate);
      if (placementKey) return PLACEMENTS[placementKey];
    }

    return DEFAULT_PLACEMENT;
  }

  window.VanscapePosterMockup = {
    placements: PLACEMENTS,
    defaultPlacement: DEFAULT_PLACEMENT,
    normalizePosterKey,
    getPlacementForVariant
  };
})();
